module.exports = __webpack_public_path__ + "img/favourite-filled.8532ec6b.svg";